import { FanModel } from '@modules/fan/fan-model';

const { fields } = FanModel;

export default [
  fields.id,
  fields.name,
  fields.lastName,
  fields.uid,
  fields.teams,
  fields.createdAt
];
